module.exports = `//${location.host}/frontend-home/setup.js/index.jsp?noext=1` +
    (location.search ? `&${location.search.slice(1)}` : '');
